/**
 * Article Feedback actions
 */
import { createAction } from '../types/utils';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["FEEDBACK_REACTION_PRESSED"] = "articleFeedback::feedback_reaction_pressed";
    ActionTypes["FEEDBACK_REACTION_SUBMITTED"] = "articleFeedback::feedback_reaction_submitted";
    ActionTypes["FEEDBACK_REACTION_ERROR"] = "articleFeedback::feedback_reaction_error";
    ActionTypes["NEGATIVE_FEEDBACK_SKIPPED"] = "articleFeedback::negative_feedback_skipped";
    ActionTypes["NEGATIVE_FEEDBACK_SUBMIT"] = "articleFeedback::negative_feedback_submit";
    ActionTypes["NEGATIVE_FEEDBACK_SUBMIT_ERROR"] = "articleFeedback::negative_feedback_submit_error";
    ActionTypes["NEGATIVE_FEEDBACK_SUBMIT_SUCCESS"] = "articleFeedback::negative_feedback_submit_success";
})(ActionTypes || (ActionTypes = {}));
export const Actions = {
    feedbackReactionPressed: (articleId, title, isPositive) => createAction(ActionTypes.FEEDBACK_REACTION_PRESSED, {
        articleId,
        title,
        isPositive,
    }),
    feedbackReactionSubmitted: (articleId, isPositive) => createAction(ActionTypes.FEEDBACK_REACTION_SUBMITTED, {
        articleId,
        isPositive,
    }),
    feedbackReactionError: (articleId, isPositive) => createAction(ActionTypes.FEEDBACK_REACTION_ERROR, {
        articleId,
        isPositive,
    }),
    negativeFeedbackSkipped: (articleId) => createAction(ActionTypes.NEGATIVE_FEEDBACK_SKIPPED, {
        articleId,
    }),
    negativeFeedbackSubmit: (articleId, title, formData) => createAction(ActionTypes.NEGATIVE_FEEDBACK_SUBMIT, {
        articleId,
        title,
        formData,
    }),
    negativeFeedbackSubmitError: (articleId) => createAction(ActionTypes.NEGATIVE_FEEDBACK_SUBMIT_ERROR, {
        articleId,
    }),
    negativeFeedbackSubmitSuccess: (articleId) => createAction(ActionTypes.NEGATIVE_FEEDBACK_SUBMIT_SUCCESS, {
        articleId,
    }),
};
//# sourceMappingURL=articleFeedback.js.map